import { PackageCategory } from '../../models';
import { EnumHelper } from '@brokerportal/common/utils';

// TODO: Refactor to `PackageCategoryInput = PackageCategory | `${PackageCategory}`` after TypeScript 4.1 is widely adopted
export type PackageCategoryInput = PackageCategory | 'battery' | 'solar' | 'inverter' | 'dcIsolator';

export const coercePackageCategoryProperty = (value: PackageCategoryInput): PackageCategory => {
    return EnumHelper.cast(PackageCategory, value) ?? (value as PackageCategory);
};
